var classes = {"root":"ahc8m","viewport":"LLE84","container":"Le96v","controls":"ietvU","control":"ZfMAh","controlLeftHidden":"_5fdcq","controlRightHidden":"pIa3G","indicators":"_0lOqX","slide":"fSTQ-"};

export { classes as default };
